import {
    DeleteCommentResponse,
    DenounceComment,
    SubmitComment,
    SubmitCommentResponse
} from '../store/contributions/contributionsTypings'
import { getWrapper } from './axios'
import { formDataToRequestParams } from './helpers'
import { EmphemeralListTypings } from '../store/ephemeral/ephemeralTypings'

export const submitComment = (params: SubmitComment): Promise<SubmitCommentResponse> => {
    return getWrapper(
        '/comment/submit',
        formDataToRequestParams<SubmitComment>(params),
        true
    ) as Promise<SubmitCommentResponse>
}

export const postDeleteComment = (params: { id: number | string }): Promise<DeleteCommentResponse> => {
    return getWrapper(
        '/comment/delete',
        formDataToRequestParams<{ id: number | string }>(params),
        true
    ) as Promise<DeleteCommentResponse>
}

export const postDenounceComment = (params: DenounceComment): Promise<DeleteCommentResponse> => {
    return getWrapper(
        '/denouncement/send',
        formDataToRequestParams<DenounceComment>(params),
        true
    ) as Promise<DeleteCommentResponse>
}

export const getContributionComments = (params: {
    object_type: 'contribution' | 'contribution_comment' | 'contribution_material'
    object_id: number
    offset?: number
    limit?: number
}): Promise<EmphemeralListTypings> => {
    return getWrapper(
        `/comment/list?object_type=${params.object_type}&object_id=${params.object_id}&offset=${
            params.offset ?? 0
        }&limit=${params.limit ?? 10}`
    ) as Promise<EmphemeralListTypings>
}

export const getLikeList = (params: {
    object_type: 'contribution' | 'contribution_material' | 'contribution_comment' | 'ephemeral_post'
    object_id: number
    offset?: number
    limit?: number
}): Promise<EmphemeralListTypings> => {
    return getWrapper(
        `/like/list?object_type=${params.object_type}&object_id=${params.object_id}&offset=${
            params.offset ?? 0
        }&limit=${params.limit ?? 10}`
    ) as Promise<EmphemeralListTypings>
}

export const likeSet = (params: {
    object_type:
        | 'contribution'
        | 'contribution_comment'
        | 'ephemeral_post'
        | 'contribution_material'
        | 'contribution_material_comment'
    object_id: number
}): Promise<EmphemeralListTypings> => {
    return getWrapper(
        `/like/set?object_type=${params.object_type}&object_id=${params.object_id}`
    ) as Promise<EmphemeralListTypings>
}

export const likeCancel = (params: {
    object_type:
        | 'contribution'
        | 'contribution_comment'
        | 'ephemeral_post'
        | 'contribution_material'
        | 'contribution_material_comment'
    object_id: number
}): Promise<EmphemeralListTypings> => {
    return getWrapper(
        `/like/cancel?object_type=${params.object_type}&object_id=${params.object_id}`
    ) as Promise<EmphemeralListTypings>
}
